import { usePayoutsById } from "@hooks/payouts/usePayouts";
import Dialog from "@mui/material/Dialog";
import React from "react";
import { OrderDetails, PayoutContent } from "types/payouts/payoutTypes"; // Assuming the type definition is in a separate file

interface PayoutModalProps {
  data: PayoutContent;
  closeModal: () => void;
  open: boolean;
}

const PayoutModal: React.FC<PayoutModalProps> = ({
  data,
  open,
  closeModal,
}) => {
  const { data: payout, isLoading, error } = usePayoutsById(data.payoutId);
  console.log("payouts", payout?.orderDetails);
  const parseOrderDetails = (orderDetailString: string) => {
    const parts = orderDetailString.split(", ");
    const orderIdPart = parts[0].split(": ")[1];
    const itemsPart = parts[1].split(": ")[1];
    const amountPart = parts[2].split(": ")[1];
    return {
      orderId: orderIdPart,
      items: itemsPart,
      amount: amountPart,
    };
  };
  return (
    <div className="modal-backdrop">
      <Dialog onClose={closeModal} aria-labelledby="modal" open={open}>
        <div className="modal-payout">
          <div className="modal-heading">
            <h2>
              Payout Details: <span> {data.foodCourtName}</span>
            </h2>
            <i
              className="bx bx-x"
              onClick={closeModal}
              style={{ cursor: "pointer" }}
            />
          </div>
          <div className="payout-summary">
            <p>
              Total Earnings: <span>₹{data.payoutAmount}</span>
            </p>
            <p>
              Net Amount Paid: <span>₹{data.payoutAmount}</span>
            </p>
            <p>Date: {data.payoutDate}</p>
            <button style={{ borderRadius: 5, letterSpacing: 0.5,lineHeight:2 }} className={`status ${data?.status.toLowerCase()}`}>{data?.status}</button>
          </div>
          <div className="deductions">
            <h4>Deductions</h4>
            <div className="tax-fees">
              <p>
                Tax: <span>₹{0.00}</span>
              </p>
              <p>
                Service Fees: <span>₹{0.00}</span>
              </p>
            </div>
          </div>
          <h3>Transaction History</h3>
          <div className="transaction-table-container">
            <table className="payout-table">
              <thead>
                <tr>
                  <th>OrderID</th>
                  <th>Order Items</th>
                  <th>Date and Time</th>
                  <th>Status</th>
                  <th>Transaction Amount</th>
                </tr>
              </thead>
              <tbody>
                {!isLoading?
                  (payout?.orderDetails?.map((detailString: string, index: number) => {
                    const parsedDetail = parseOrderDetails(detailString);
                    return (
                      <tr key={index}>
                        <td className="orderId">{parsedDetail.orderId}</td>
                        <td>{parsedDetail.items || "No items"}</td>
                        <td>{"12/12/2002"}</td>
                        <td>{"Completed"}</td>
                        <td>₹{parsedDetail.amount}</td>
                      </tr>
                    );
                  }))
                  :
                   (<tr><td>Loading...</td></tr>)
                }
              </tbody>
            </table>
          </div>
          {/* <div className="modal-actions">
            <button className="cancel-btn" onClick={closeModal}>
              Cancel
            </button>
            <button className="save-btn">Save</button>
          </div> */}
        </div>
      </Dialog >
    </div >
  );
};

export default PayoutModal;
